import {
  CORE_LOAD_FOODS_REQUEST,
  CORE_LOAD_FOODS_SUCCESS,
} from '../../types'

const initialState = []
export default {
  foods: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FOODS_REQUEST:
        return initialState
      case CORE_LOAD_FOODS_SUCCESS:
        if (action.payload[0]) {
          let payload = action.payload[0]
          let amenities = []
          for (let i = 0; i < payload.length; i++) {
            amenities.push({
              name: payload[i].name,
              _id: payload[i]._id
            })
          }
          return amenities
        }
        else return [{}]

      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/front/features/foods/reducer.js